import { apiClient } from './client';
import type { BedrockModelInfo, GrammarCheckResult } from '@peles/shared';
import { extractApiErrorMessage } from '../utils/apiError';

/** List Bedrock foundation models for the App Settings model picker. */
export async function fetchBedrockModels(): Promise<BedrockModelInfo[]> {
  const { data } = await apiClient.get<BedrockModelInfo[]>('/ai/models');
  return data;
}

/** Run a spelling/grammar pass over a draft message. */
export async function checkGrammar(text: string): Promise<GrammarCheckResult> {
  try {
    const { data } = await apiClient.post<GrammarCheckResult>('/ai/grammar-check', { text });
    return data;
  } catch (err) {
    // Surface the server's message (e.g. the Bedrock failure reason) rather
    // than the generic "Request failed with status code 502".
    throw new Error(extractApiErrorMessage(err, 'The grammar assistant is unavailable.'));
  }
}
